import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import colors from 'constants/styles/colors';
import media from 'constants/styles/media';
import { SECTION_IDS, PHONE_NUMBER_E164 } from 'constants/index';
import layout from 'constants/styles/layout';
import logoUrl from '../../images/svg/logo.svg';

const SFooter = styled.footer`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${colors.gray_90};
    margin-top: ${layout.sectionSpacing};
    padding: 30px 0;

    @media (max-width: ${media.tablet}) {
        margin-top: ${layout.sectionSpacingMobile};
        padding: 36px 0;
    }
`;

const SContent = styled.div`
    width: 100%;
    max-width: ${layout.contentMaxWidth};
    padding: ${layout.contentSpacing};
    display: flex;
    flex-direction: column;
`;

const STop = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 36px;
    margin-bottom: 36px;

    @media (max-width: ${media.tablet}) {
        flex-direction: column;
    }
`;

const SBrand = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const SCompany = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: ${colors.gray_40};
    font-size: 14px;
    line-height: 20px;
`;

const SBottom = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;

    @media (max-width: ${media.tablet}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const SLinks = styled.div`
    display: flex;
    align-items: center;
    gap: 48px;

    @media (max-width: ${media.tablet}) {
        flex-direction: column;
        gap: 12px;
    }
`;

const SParagraph = styled.p`
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${colors.gray_40};
    text-decoration: none;
`;

const SCopyright = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${colors.gray_40};
`;

export const Footer = () => {
    const { t } = useTranslation();

    return (
        <SFooter id={SECTION_IDS.FOOTER}>
            <SContent>
                <STop>
                    <SBrand>
                        <img src={logoUrl} alt="TURO" />
                        <SCompany>
                            <SParagraph>{t('footer.company')}</SParagraph>
                            <SParagraph>{t('footer.adress')}</SParagraph>
                            <SParagraph>{t('footer.adress2')}</SParagraph>
                            <SParagraph as="a" href={`tel:${PHONE_NUMBER_E164}`}>
                                {t('footer.phone')}
                            </SParagraph>
                        </SCompany>
                    </SBrand>
                </STop>

                <SBottom>
                    <SLinks>
                        <SParagraph>{t('footer.privacyPolicy')}</SParagraph>
                        <SParagraph>{t('footer.terms')}</SParagraph>
                    </SLinks>
                    <SCopyright>{t('footer.copyright')}</SCopyright>
                </SBottom>
            </SContent>
        </SFooter>
    );
};
